<!-- 리더십 > 안전리더십 관리 상세 > 리스트 -->
<template>
  <div class="content-wrap">
    <NaviBox02 ref=" "/>
    <div class="tit-group02 ty03">
      <h2 class="tit">{{t('message.safetyLeadershipPlanManagement')}}</h2>
    </div>
    <div class="content-box">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt-total">Total: {{ totalCnt }}</div>
            <c-InputSearch :placeholder="t('message.searchMultiPlaceholder')" v-model="inputSearch" @search-word="onClickSearch"/>
          </div>
          <div class="wr">
            <c-btn01 :btnText="t('message.newRegistration')" @click="onClickViewPage"/>
          </div>
        </div>
      </div>
      <!-- v-data-table 가져옴-->
      <div class="tbl-group size-custom6">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :items-per-page-options="footerOptions"
          return-object
          show-select
          @click:row="onClickViewPage"
        >
          <template v-slot:item.title="{ item }">
            <div class="flex-l">
              <v-btn variant="text" @click="utils.movePage('/safetyLeadershipManagementDetail')">
                <div class="ell01">
                  {{item.title}}
                </div>
              </v-btn>
            </div>
          </template>
          <template v-slot:item.period="{ item }" >
            <div class="flex-c">
              {{dayjs(item.startDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(item.startDate).format('YY.MM.DD')}}
              ~{{dayjs(item.endDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(item.endDate).format('YY.MM.DD')}}
            </div>
          </template>
          <template v-slot:item.activeYn="{ item }">
            <div class="flex-c">
              {{item.activeYn=='Y'?t('message.activate'):t('message.deactivate')}}
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="bottom-btn-group">
        <div class="wl"></div>
        <div class="wr">
          <c-btnLine01 :btnText="t('message.bulkChangeStatus')" @click="onClickChangeActive" v-if="false"/>
          <c-btn02 :btnText="t('message.bulkHide')" @click="onClickChangeShow" v-if="false"/>
          <c-btn02 :btnText="t('message.bulkDelete')" @click="onClickDelete"/>
        </div>
      </div>
    </div>
  </div>
  <c-dialog v-model="dialogActiveChangeModel"
            v-bind="dialogActiveChangeBind"
            @close="dialogActiveChangeModel=false"
            @cancel="cancelChangeActive"
            @confirm="confirmChangeActive"
  />
  <c-dialog v-model="dialogShowChangeModel"
            v-bind="dialogShowChangeBind"
            @close="dialogShowChangeModel=false"
            @cancel="cancelChangeShow"
            @confirm="confirmChangeShow"
  />
  <c-dialog v-model="dialogAllDeleteModel"
            v-bind="dialogAllDeleteBind"
            @close="dialogAllDeleteModel=false"
            @confirm="confirmDelete"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const totalCnt = ref(0)
const inputSearch = ref(null)
const dialogActiveChangeModel = ref(false)
const dialogAllDeleteModel = ref(false)
const dialogShowChangeModel = ref(false)
const selected = ref([])
const items = ref([])
const childNaviBoxRef = ref(null)

//ui
const dialogActiveChangeBind = {
  dialogTit: t('message.changeLeadershipStatus'),
  dialogText: t('message.toggleSelectedLeadershipActivation'),
  btn1Text: t('message.activate'),
  btn1Show: true,
  btn2Text: t('message.deactivate'),
  btn2Show: true,
}
const dialogShowChangeBind = {
  dialogTit: t('message.toggleLeadershipVisibility'),
  dialogText: t('message.applySelectedLeadershipVisibility'),
  btn1Text: t('message.hide'),
  btn1Show: true,
  btn2Text: t('message.show'),
  btn2Show: true,
}
const dialogAllDeleteBind = {
  dialogTit: t('message.actionDelete'),
  dialogText: t('message.actionDeleteDescription'),
  btn1Text: t('message.delete'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}
const headers = ref([
  { title: t('message.title'), key: 'leadershipTitle' },
  { title: t('message.targetCount'), key: 'leadershipTargetCnt' },
  { title: t('message.period'), key: 'period'},
  //{ title: t('message.type'), key: 'type' },
])
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//hook
onMounted(() => {
  onClickSearch()
})

//function
const onClickSearch = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  const word = inputSearch.value
  let params = {
    keyword: word,
    companyIdx:companyIdx,
  }

  LeadershipService.getLeadershipList(params).then(
    (response) => {
      items.value = response.result
      totalCnt.value = items.value.length
      selected.value = []
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickChangeShow = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else
    dialogShowChangeModel.value = true
}

const cancelChangeShow = ()=>{
  updateColumn('showYn', 'Y')
}

const confirmChangeShow = ()=>{
  updateColumn('showYn', 'N')
}

const onClickChangeActive = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else
    dialogActiveChangeModel.value = true
}

const cancelChangeActive = ()=>{
  updateColumn('activeYn', 'N')
}

const confirmChangeActive = ()=>{
  updateColumn('activeYn', 'Y')
}

const onClickDelete = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else {
    if(selected.value.length)
      dialogAllDeleteModel.value = true
  }
}

const confirmDelete = ()=>{
  if(import.meta.env.MODE == 'development') {
    selected.value.forEach((item)=>{
      const idx = items.value.findIndex((tempItem)=> {return tempItem.idx === item.idx})
      if (idx > -1) items.value.splice(idx, 1)
    })

    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let updateArr = []
    selected.value.forEach((item)=>{
      updateArr.push(item.idx)
    })
    let params = {
      companyIdx:companyIdx,
      updateArr: updateArr,
    }

    LeadershipService.deleteLeadership(params).then(
      (response) => {
        if(response.success) {
          selected.value.forEach((item)=>{
            const idx = items.value.findIndex((tempItem)=>{return tempItem.idx === item.idx})
            if (idx > -1) items.value.splice(idx, 1)
          })

          selected.value = []
          snackText.value = 'success'
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const onClickViewPage = (event, row)=>{
  if(row)
    storeRef.viewIdx.value = row.item.idx
  else
    storeRef.viewIdx.value = null
  utils.movePage('/safetyLeadershipManagementDetail/'+storeRef.viewIdx.value)
}

const updateColumn = (columnKey, columnValue)=>{
  if(import.meta.env.MODE == 'development') {
    selected.value.forEach((item)=>{
      const idx = items.value.findIndex((tempItem)=>{return tempItem.idx === item.idx})
      if (idx > -1) items.value.splice(idx, 1)
    })

    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let updateArr = []
    selected.value.forEach((item)=>{
      updateArr.push(item.idx)
    })
    let params = {
      companyIdx:companyIdx,
      updateArr: updateArr,
      updateColumnKey: columnKey,
      updateColumnValue: columnValue,
    }

    LeadershipService.updateLeadershipColumn(params).then(
      (response) => {
        if(response.success) {
          onClickSearch()
          snackText.value = 'success'
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

//즐겨찾기 버튼 삭제, 사용안함
const onChangeCheck = (item, e)=>{
  let user = JSON.parse(localStorage.getItem('user'))
  let params = {
    bookmarkType:'m',
    parentIdx:item,
    memberIdx:user.memberIdx,
  }

  if(e.target.checked){
    LeadershipService.insertBookmark(params).then(
      (response) => {
        if (childNaviBoxRef.value)
          childNaviBoxRef.value.loadData('bookmark')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
  else{
    LeadershipService.deleteBookmark(params).then(
      (response) => {
        if (childNaviBoxRef.value)
          childNaviBoxRef.value.loadData('bookmark')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
</script>


<style lang="scss" scoped>
</style>
